import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=931cd8d0&"
import script from "./Address.vue?vue&type=script&lang=ts&"
export * from "./Address.vue?vue&type=script&lang=ts&"
import style0 from "./Address.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports